import cn from 'classnames';
import { useAppSelector } from '../../../../store';
import { selectTheme } from '../../../../store/theme';
import { LangSwitcher } from 'components/LangSwitcher/LangSwitcher';
import { IS_NEW_CRM } from 'config';
import './AuthPageHeader.scss';

type AuthPageHeaderProps = {
  inverse?: boolean;
};

export const AuthPageHeader = ({ inverse }: AuthPageHeaderProps) => {
  const { logo_src } = useAppSelector(selectTheme);

  return (
    <div
      className={cn(IS_NEW_CRM ? 'auth-header-new' : 'auth-header', {
        '_text-r': inverse,
      })}
    >
      <div className="auth-header-logo">
        <img src={logo_src} alt="logo" />
      </div>
      {IS_NEW_CRM ? <LangSwitcher closeOnSelect /> : null}
    </div>
  );
};
